import { ExperienceProof } from "./experienceProof";

export const experienceProofI18n: Record<
  ExperienceProof,
  {
    title: string;
  }
> = {
  [ExperienceProof.Link]: {
    title: "application:experience.field.proof.link",
  },
  [ExperienceProof.Cert]: {
    title: "application:experience.field.proof.cert",
  },
  [ExperienceProof.Screen]: {
    title: "application:experience.field.proof.screen",
  },
  [ExperienceProof.AckLetter]: {
    title: "application:experience.field.proof.ack_letter",
  },
  [ExperienceProof.AppLetter]: {
    title: "application:experience.field.proof.app_letter",
  },
};
